<template>
  <div class="bg-white px-4 rounded-tl-lg rounded-tr-lg" :class="showPlaceFull ? isMobile() ? '' : 'w-96 border-pc place-full-left' : ''">
    <div @click="togglePlace" class="w-full h-8">
      <div class="map-tip"></div>
    </div>
    <a @click="closePlace" class="btn-close">
      <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><rect height="1" rx=".5" transform="matrix(.70710678 .70710678 -.70710678 .70710678 10.010408 -4.146447)" width="16" x="2.010408" y="9.510408"/><rect height="1" rx=".5" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -4.146447 10.010408)" width="16" x="2.010408" y="9.510408"/></g></svg>
    </a>
    <div class="mt-1">
      <div class="relative">
        <template v-if="!selectedPlace.isGooglePlace && !selectedPlace.isEkispertPlace && token">
          <div class="float-right">
            <favorite :place="selectedPlace" />
          </div>
        </template>
        <template v-if="path.indexOf('editPlan') !== -1 || path.indexOf('newPlan') !== -1">
          <div class="float-right plan-add">
            <a @click="addPlace">
              <div class="plan-add-icon">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 19 19"><path d="m370.514 224.9c.476 0 .882-.175 1.218-.525s.504-.763.504-1.239v-10.5c0-.476-.168-.882-.504-1.218s-.742-.504-1.218-.504h-10.5c-.476 0-.889.168-1.239.504s-.525.742-.525 1.218v10.5c0 .476.175.889.525 1.239s.763.525 1.239.525zm-4.389-2.625h-1.764v-3.486h-3.486v-1.764h3.486v-3.486h1.764v3.486h3.486v1.764h-3.486zm2.625 6.111v-1.722h-12.264v-12.264h-1.722v12.264c0 .476.168.882.504 1.218s.742.504 1.218.504z" transform="translate(-354 -210)" /></svg>
              </div>
            </a>
          </div>
        </template>
        <h2 class="pr-10 text-lg font-bold">
          {{ selectedPlace.name }}
        </h2>
      </div>
      <div class="mt-2 mb-1">
        <p v-for="benefit in selectedPlace.benefits" v-bind:key="benefit.id" class="inline-block py-1 px-2 mb-1 mr-2 border border-pass rounded text-pass text-sm text-center leading-none">
          {{ benefit.name }}
        </p>
      </div>
    </div>
    <div v-if="showPlaceFull" class="my-2">
      <place-full class="mt-2" :place="selectedPlace" @onRingoPass="onRingoPass" />
      <place-action :place="selectedPlace" :addPlace="addPlace" @closeMap="closeMap" />
      <div class="h-2"></div>
    </div>
    <div v-else @click="openPlaceDetail" class="pt-2 text-sm text-gray-600">
      <div class="text-center">
        {{$t('tour_place_detail_open')}}
      </div>
      <div class="m-auto text-center w-2">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M7 10l5 5 5-5z"/></svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PlaceFull from './PlaceFull'
import Favorite from '../../molecules/Favorite'
import PlaceAction from './PlaceAction'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    PlaceFull,
    Favorite,
    PlaceAction
  },
  computed: {
    ...mapGetters({
      selectedPlace: 'drawer/getSelectedPlace',
      placeFull: 'places/getPlaceFull',
      showPlaceFull: 'drawer/getShowPlaceFull',
      from: 'map/getFrom',
      token: 'user/getToken',
      spotMarkerList: 'map/getSpotMarkerList'
    })
  },
  data () {
    return {
      path: null
    }
  },
  created () {
    this.path = this.$route.path
  },
  methods: {
    closePlace: function () {
      this.$store.dispatch('map/updateGooglePlaceMarker', {})
      this.$store.dispatch('drawer/openPlace', { place: {}, full: false })
      if (this.spotMarkerList.length > 0) {
        this.$store.dispatch('drawer/openSpotMarkerList')
      }
    },
    openPlaceDetail: function () {
      if(!this.$store.getters['drawer/getIsFull']) {
        this.$gtag.event("POI詳細表示", {
          poi_id: this.selectedPlace.id,
          poi_name: this.selectedPlace.name
        });
        this.$store.dispatch('drawer/openPlace', { place: this.selectedPlace, full: true })
      }
    },
    togglePlace: function () {
      this.$gtag.event("POI詳細表示", {
        poi_id: this.selectedPlace.id,
        poi_name: this.selectedPlace.name
      });
      const full = !this.$store.getters['drawer/getIsFull']
      this.$store.dispatch('drawer/openPlace', { place: this.selectedPlace, full: full })
    },
    addPlace: function () {
      if (this.selectedPlace.id) {
        this.$store.dispatch('loading/beginLoading')
        this.$store.dispatch('places/fetchPlace', this.selectedPlace.id)
          .then((p) => {
            const place = {
              name: p['shop_name'],
              location: {
                latitude: p.latitude,
                longitude: p.longitude
              },
              detail: p['shop_introduction'],
              image: p.image,
              genreIds: ["other"]
            }
            // GoogleAnalytics
            this.$gtag.event("プランにPOI追加", {
              poi_name: place.name
            });
            const params = {
              route: this.from.route,
              place: place,
              visit: 60
            }
            if (place.genreIds.indexOf('TH6_tag159') != -1) {
              // デフォルトのチェックイン／アウト時間は18:00／10:00(滞在16時間=960分)
              params.visit = 960
              const startTime = this.$store.getters['condition/getTime']
              const checkinTime = moment(startTime).set('hour', 18)
              this.$store.dispatch('condition/updateTime', checkinTime)
              this.$store.dispatch('destinations/spliceDestinationLock', params)
              this.$store.dispatch('destinations/setStay', { route: this.from.route})
            } else {
              this.$store.dispatch('destinations/spliceDestination', params)
            }
            this.$store.dispatch('routes/search')
            this.$emit('closeMap')
          })
          .finally(() => {
            this.$store.dispatch('loading/endLoading')
          })
      } else {
        // GoogleAnalytics
        this.$gtag.event("プランにPOI追加", {
          poi_name: this.selectedPlace.name
        });
        if (this.selectedPlace.genreIds === undefined){
          this.selectedPlace.genreIds = ["other"]
        }
        const params = {
          route: this.from.route,
          place: this.selectedPlace,
          visit: 60
        }
        this.$store.dispatch('destinations/spliceDestination', params)
        this.$store.dispatch('routes/search')
        this.$emit('closeMap')
      }
    },
    onRingoPass: function (url) {
      this.$emit('onRingoPass', url)
    },
    closeMap: function () {
      this.$emit('closeMap')
    },
    isMobile: function () {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("iphone") != -1 || userAgent.indexOf("android") != -1) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>

<style scoped>
.place-full-left {
  margin-left: -4px;
}
</style>